import PropTypes from 'prop-types'
import React from 'react'

export default class Timer extends React.Component {
  interval = null

  static propTypes = {
    startTimeSeconds: PropTypes.number.isRequired,
    timeLimit: PropTypes.number,
    overLimitCallback: PropTypes.func,
    label: PropTypes.string
  }

  constructor(props) {
    super(props)

    this.state = {
      startTimeSeconds: this.props.startTimeSeconds
    }
  }

  componentDidMount() {
    // Start timer
    this.interval = setInterval(this.addSecond, 1000)
  }

  componentWillUnmount() {
    // Unmounting component, stop timer and don't make further state changes
    clearInterval(this.interval)
  }

  addSecond = () => {
    if (this.props.timeLimit && this.props.overLimitCallback &&
       this.state.startTimeSeconds + 1 > this.props.timeLimit) {
      this.props.overLimitCallback()
      clearInterval(this.interval)
      return
    }

    this.setState({ startTimeSeconds: this.state.startTimeSeconds + 1 })
  }

  renderTime = (timeInSeconds) => {
    let renderedTime = ''

    if (timeInSeconds > (60*60*24)) {
      renderedTime += `${Math.floor(timeInSeconds / (60*60*24))} days, `
    }

    renderedTime += new Date(timeInSeconds * 1000).toISOString().substr(11, 8)

    return renderedTime
  }

  render() {
    let { timeLimit } = this.props

    if (timeLimit > 0) {
      return (
        <div>
          {
            timeLimit
              ? `Time Limit: ${this.renderTime(timeLimit)} `
              : null
          }
          { this.props.label ? `${this.props.label}: ` : '' }
          { /* Timer since quiz started */ }
          { this.renderTime(this.state.startTimeSeconds) }
        </div>
      )
    } else {
      return ( <div></div> )
    }
  }
}
